"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OCS_SI_COLUMN_FORMATS = exports.OCS_DEDUPLICATION_KEYS = exports.AbsoluteMaximumRatingsNormalizedSchema = exports.BoundaryConditionNormalizedForAmrsSchema = exports.OperatingCharacteristicsNormalizedSchema = exports.BoundaryConditionNormalizedSchema = exports.NormalizedBoundaryConditionTypeWithoutNominal = exports.NormalizedBoundaryConditionType = void 0;
exports.convertComponentBoundariesToNormalizedFormat = convertComponentBoundariesToNormalizedFormat;
exports.convertExtractedBoundariesToNormalizedFormat = convertExtractedBoundariesToNormalizedFormat;
exports.convertComponentBoundariesToNormalizedAmrFormat = convertComponentBoundariesToNormalizedAmrFormat;
exports.convertExtractedAmrBoundariesToNormalizedFormat = convertExtractedAmrBoundariesToNormalizedFormat;
exports.ocsPrescoreTransform = ocsPrescoreTransform;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
var NormalizedBoundaryConditionType;
(function (NormalizedBoundaryConditionType) {
    NormalizedBoundaryConditionType["minimum"] = "minimum";
    NormalizedBoundaryConditionType["nominal"] = "nominal";
    NormalizedBoundaryConditionType["maximum"] = "maximum";
})(NormalizedBoundaryConditionType || (exports.NormalizedBoundaryConditionType = NormalizedBoundaryConditionType = {}));
var NormalizedBoundaryConditionTypeWithoutNominal;
(function (NormalizedBoundaryConditionTypeWithoutNominal) {
    NormalizedBoundaryConditionTypeWithoutNominal["minimum"] = "minimum";
    NormalizedBoundaryConditionTypeWithoutNominal["maximum"] = "maximum";
})(NormalizedBoundaryConditionTypeWithoutNominal || (exports.NormalizedBoundaryConditionTypeWithoutNominal = NormalizedBoundaryConditionTypeWithoutNominal = {}));
exports.BoundaryConditionNormalizedSchema = zod_1.z.object({
    signalName: zod_1.z.string(),
    characteristic: sigma_engine_shared_1.BoundaryCharacteristicSchema,
    normalizedBoundaryConditionType: zod_1.z.nativeEnum(NormalizedBoundaryConditionType),
    relativeToSignalName: zod_1.z.string(),
    value: zod_1.z.string(),
});
exports.OperatingCharacteristicsNormalizedSchema = zod_1.z.object({
    operatingCharacteristics: zod_1.z.array(exports.BoundaryConditionNormalizedSchema),
});
exports.BoundaryConditionNormalizedForAmrsSchema = exports.BoundaryConditionNormalizedSchema.extend({
    normalizedBoundaryConditionType: zod_1.z.nativeEnum(NormalizedBoundaryConditionTypeWithoutNominal),
});
exports.AbsoluteMaximumRatingsNormalizedSchema = zod_1.z.object({
    amrs: zod_1.z.array(exports.BoundaryConditionNormalizedForAmrsSchema),
});
function _convertComponentBoundariesToNormalizedFormat(boundaries, signals, includeNominal) {
    const result = [];
    const nominalBoundaries = [];
    for (const boundaryWrapper of boundaries) {
        const boundary = boundaryWrapper.boundary;
        if (boundary.type !== 'numerical') {
            continue;
        }
        const numerical = boundary.numerical;
        const targetSignalIds = (0, sigma_engine_shared_1.getBoundaryTargetSignalIds)(signals, boundary.target);
        const relativeSignalIds = (0, sigma_engine_shared_1.getBoundaryTargetSignalIds)(signals, boundary.relative_to);
        const relativeSignal = relativeSignalIds.length > 0 ? signals.find((s) => s.id === relativeSignalIds[0]) : undefined;
        const relativeSignalName = relativeSignal ? relativeSignal.name : 'RELATIVE-SIGNAL-MISSING';
        for (const targetSignalId of targetSignalIds) {
            const targetSignal = signals.find((s) => s.id === targetSignalId);
            if (!targetSignal) {
                continue;
            }
            if (numerical.type === 'range') {
                if (numerical.minVal !== undefined && numerical.minVal !== null) {
                    result.push({
                        signalName: targetSignal.name,
                        characteristic: numerical.characteristic,
                        normalizedBoundaryConditionType: NormalizedBoundaryConditionType.minimum,
                        relativeToSignalName: relativeSignalName,
                        value: String(numerical.minVal),
                    });
                }
                if (numerical.maxVal !== undefined && numerical.maxVal !== null) {
                    result.push({
                        signalName: targetSignal.name,
                        characteristic: numerical.characteristic,
                        normalizedBoundaryConditionType: NormalizedBoundaryConditionType.maximum,
                        relativeToSignalName: relativeSignalName,
                        value: String(numerical.maxVal),
                    });
                }
                if (numerical.nominalValue !== undefined && numerical.nominalValue !== null) {
                    const nominalBoundary = {
                        signalName: targetSignal.name,
                        characteristic: numerical.characteristic,
                        normalizedBoundaryConditionType: NormalizedBoundaryConditionType.nominal,
                        relativeToSignalName: relativeSignalName,
                        value: String(numerical.nominalValue),
                    };
                    if (includeNominal) {
                        result.push(nominalBoundary);
                    }
                    else {
                        nominalBoundaries.push(nominalBoundary);
                    }
                }
            }
            else if (numerical.type === 'minimum') {
                result.push({
                    signalName: targetSignal.name,
                    characteristic: numerical.characteristic,
                    normalizedBoundaryConditionType: NormalizedBoundaryConditionType.minimum,
                    relativeToSignalName: relativeSignalName,
                    value: String(numerical.value),
                });
                if (numerical.nominalValue !== undefined && numerical.nominalValue !== null) {
                    const nominalBoundary = {
                        signalName: targetSignal.name,
                        characteristic: numerical.characteristic,
                        normalizedBoundaryConditionType: NormalizedBoundaryConditionType.nominal,
                        relativeToSignalName: relativeSignalName,
                        value: String(numerical.nominalValue),
                    };
                    if (includeNominal) {
                        result.push(nominalBoundary);
                    }
                    else {
                        nominalBoundaries.push(nominalBoundary);
                    }
                }
            }
            else if (numerical.type === 'maximum') {
                result.push({
                    signalName: targetSignal.name,
                    characteristic: numerical.characteristic,
                    normalizedBoundaryConditionType: NormalizedBoundaryConditionType.maximum,
                    relativeToSignalName: relativeSignalName,
                    value: String(numerical.value),
                });
                if (numerical.nominalValue !== undefined && numerical.nominalValue !== null) {
                    const nominalBoundary = {
                        signalName: targetSignal.name,
                        characteristic: numerical.characteristic,
                        normalizedBoundaryConditionType: NormalizedBoundaryConditionType.nominal,
                        relativeToSignalName: relativeSignalName,
                        value: String(numerical.nominalValue),
                    };
                    if (includeNominal) {
                        result.push(nominalBoundary);
                    }
                    else {
                        nominalBoundaries.push(nominalBoundary);
                    }
                }
            }
            else if (numerical.type === 'absolute') {
            }
        }
    }
    if (!includeNominal && nominalBoundaries.length > 0) {
        nominalBoundaries.forEach((boundary) => {
            console.warn(`[AMR Conversion] Nominal value detected and excluded: signal="${boundary.signalName}", ` +
                `characteristic="${boundary.characteristic}", value="${boundary.value}", ` +
                `relativeToSignal="${boundary.relativeToSignalName}"`);
        });
    }
    return result;
}
function convertComponentBoundariesToNormalizedFormat(boundaries, signals) {
    return _convertComponentBoundariesToNormalizedFormat(boundaries, signals, true);
}
function convertExtractedBoundariesToNormalizedFormatShared(extractedCharacteristics, includeNominal) {
    const result = [];
    const nominalBoundaries = [];
    for (const characteristic of extractedCharacteristics) {
        if (characteristic.minimum !== null && characteristic.minimumRelativeToSignalName !== null) {
            result.push({
                signalName: characteristic.signalName,
                characteristic: characteristic.characteristic,
                normalizedBoundaryConditionType: NormalizedBoundaryConditionType.minimum,
                relativeToSignalName: characteristic.minimumRelativeToSignalName,
                value: characteristic.minimum,
            });
        }
        if (characteristic.maximum !== null && characteristic.maximumRelativeToSignalName !== null) {
            result.push({
                signalName: characteristic.signalName,
                characteristic: characteristic.characteristic,
                normalizedBoundaryConditionType: NormalizedBoundaryConditionType.maximum,
                relativeToSignalName: characteristic.maximumRelativeToSignalName,
                value: characteristic.maximum,
            });
        }
        if (characteristic.nominal !== undefined &&
            characteristic.nominal !== null &&
            characteristic.nominalRelativeToSignalName !== undefined &&
            characteristic.nominalRelativeToSignalName !== null) {
            const nominalBoundary = {
                signalName: characteristic.signalName,
                characteristic: characteristic.characteristic,
                normalizedBoundaryConditionType: NormalizedBoundaryConditionType.nominal,
                relativeToSignalName: characteristic.nominalRelativeToSignalName,
                value: characteristic.nominal,
            };
            if (includeNominal) {
                result.push(nominalBoundary);
            }
            else {
                nominalBoundaries.push(nominalBoundary);
            }
        }
    }
    if (!includeNominal && nominalBoundaries.length > 0) {
        nominalBoundaries.forEach((boundary) => {
            console.warn(`[AMR Conversion] Nominal value detected and excluded: signal="${boundary.signalName}", ` +
                `characteristic="${boundary.characteristic}", value="${boundary.value}", ` +
                `relativeToSignal="${boundary.relativeToSignalName}"`);
        });
    }
    return result;
}
function convertExtractedBoundariesToNormalizedFormat(extractedCharacteristics) {
    return convertExtractedBoundariesToNormalizedFormatShared(extractedCharacteristics, true);
}
function convertComponentBoundariesToNormalizedAmrFormat(boundaries, signals) {
    const allBoundaries = _convertComponentBoundariesToNormalizedFormat(boundaries, signals, false);
    return allBoundaries
        .filter((boundary) => boundary.normalizedBoundaryConditionType !== NormalizedBoundaryConditionType.nominal)
        .map((boundary) => ({
        signalName: boundary.signalName,
        characteristic: boundary.characteristic,
        normalizedBoundaryConditionType: boundary.normalizedBoundaryConditionType,
        relativeToSignalName: boundary.relativeToSignalName,
        value: boundary.value,
    }));
}
function convertExtractedAmrBoundariesToNormalizedFormat(extractedAmrs) {
    const allBoundaries = convertExtractedBoundariesToNormalizedFormatShared(extractedAmrs, false);
    return allBoundaries
        .filter((boundary) => boundary.normalizedBoundaryConditionType !== NormalizedBoundaryConditionType.nominal)
        .map((boundary) => ({
        signalName: boundary.signalName,
        characteristic: boundary.characteristic,
        normalizedBoundaryConditionType: boundary.normalizedBoundaryConditionType,
        relativeToSignalName: boundary.relativeToSignalName,
        value: boundary.value,
    }));
}
exports.OCS_DEDUPLICATION_KEYS = [
    'signalName',
    'characteristic',
    'normalizedBoundaryConditionType',
    'relativeToSignalName',
    'value',
];
exports.OCS_SI_COLUMN_FORMATS = {
    value: sigma_engine_shared_1.BoundaryCharacteristic.Voltage,
};
function ocsPrescoreTransform(rows) {
    return rows.map((row) => {
        const signalName = row.signalName;
        const characteristic = row.characteristic;
        const normalizedBoundaryConditionType = row.normalizedBoundaryConditionType;
        const relativeToSignalName = row.relativeToSignalName;
        let value = row.value;
        try {
            const parsed = sigma_engine_shared_1.Utils.parseNumericalSIValue(row.value, sigma_engine_shared_1.BoundaryCharacteristicSIDefinitions[sigma_engine_shared_1.BoundaryCharacteristic.Voltage]);
            if (parsed !== undefined) {
                value = String(parsed);
            }
        }
        catch {
        }
        return {
            compositeKey: `signalName:${signalName},characteristic:${characteristic},normalizedBoundaryConditionType:${normalizedBoundaryConditionType},relativeToSignalName:${relativeToSignalName},value:${value}`,
        };
    });
}
//# sourceMappingURL=boundary-conditions-normalized.js.map